export { FooterModule } from './lib/footer.module';
